<template>

        <div>
                            <h1>已購買課程</h1><!--目前所在頁面標題-->
                            <section class="conditionSection">
                                <!-- <fieldset>
                                    <legend>排序：</legend>
                                    <div class="inputText">
                                        <select name="" id="">
                                            <option selected="selected" value="%">依上架時間</option>
                                            <option value="01">依更新時間</option>
                                            <option value="02">依熱門排序</option>
                                        </select>
                                    </div>
                                </fieldset> -->
                            </section>
                            <section class="normalList" >
                                <ul class="slick_list course_style2">
                                    <li  v-for = "propertiesData in propertiesDatas">
                                        <figure>
                                            <div class="graphic"><img v-bind:src="propertiesData.channel.imgCover"></div>
                                        </figure>
                                        <figcaption>
                                            <h3>{{propertiesData.channel.title}}</h3><!--課程名稱-->
                                            <i v-if="propertiesData.points != null">{{propertiesData.channel.total}}堂課 / {{propertiesData.points}}點</i>
                                            <i v-else>{{propertiesData.channel.total}}堂課 </i>

                                            <b>{{propertiesData.channel.author.title}}</b><!--大師名稱-->
                                        </figcaption>
                                        <!-- <a href="course.html" class="fullLink" title="寶寶怎麼養才好"></a> -->
                                        <router-link v-bind:to="'/channel/'+propertiesData.channel.id"> <a :href="'/channel/'+propertiesData.channel.id" class="fullLink"></a></router-link>

                                    </li>
                                </ul>
                            </section>

                            <section class="emptyPage"  v-if="propertiesDatas.length == 0">
                                <div class="wrap">
                                    <figure>
                                        <img src="@/assets/images/status_empty_cart.png" alt="尚未購買課程">
                                        <figcaption>
                                            您尚未購買課程喔！
                                        </figcaption>
                                    </figure>
                                </div>
                            </section>
                            
                        </div>
                        </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
        name: 'async',
    metaInfo () {
      return {
        
        title: '已購買課程 | 我的 | 一刻鯨選',
        meta: [
            // OpenGraph data (Most widely used)
            {property: 'og:title', content: '已購買課程 | 我的 | 一刻鯨選'},
            {property: 'og:site_name', content: '已購買課程 | 我的 | 一刻鯨選'},
            // The list of types is available here: http://ogp.me/#types
            {property: 'og:type', content: 'website'},
            // Should the the same as your canonical link, see below.
            {property: 'og:url', content: window.location.toString()},
            {property: 'og:image', content: this.$store.state.urlDomain+'/static/logo.jpg'},
            // Often the same as your meta description, but not always.
            {property: 'og:description', content: '登入後，即可查看帳戶所有資訊。'},
        
        ]
      }
    },
data() {
        return {
            propertiesDatas:[],
        }
     },
     computed: {
    ...mapGetters(["userInfo,credentialToken"])
    
  },

  created() {
  
    this.axios
       .get(this.$store.getters.baseURL + 'properties', { headers: {"Authorization" : `Bearer ${localStorage.getItem('credentialToken')}`} })
      .then(response => {
          this.propertiesDatas = response.data

      })
      .catch(error => console.log("log:"+error));
  },

};
</script>

<style>

@import '../../../assets/css/user.css';
@import '../../../assets/css/user_rwd.css';
 body {padding-top: 0;}
 /* body {padding-top: 0;}
 .bodyHeader {display: none;} */
</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MyCourse.vue